module.exports = __webpack_public_path__ + "media/images/common/lp/bg-presentAmazon-right-3fd60e136ea58a3ce3ca21bdd54bdc8c.svg";